import React, { useContext } from "react";

import constant from "lib/constant/constant";

import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import { storageHelper } from "lib/helpers";
import NotFound from "layout/private/components/notFound/notFound";

// import { AdminOrderList } from "./admin/features";
import { OperatorOrderList } from "./operator/features";
import { ProviderOrderList } from "./provider/features";

const { userKey } = constant;
const { admin, operator, provider } = userKey;

const OrderList = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    // if (role === admin) {
    //   return <AdminOrderList />;
    // }
    if (role === operator) {
      return <OperatorOrderList />;
    }
    if (role === provider) {
      return <ProviderOrderList />;
    }

    return <NotFound />;
  };

  const currentUserRole = storageHelper.get("userRole");
  const OrderListComponent = getComponent(currentUserRole);
  return OrderListComponent;
};

export default OrderList;
